import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';

import themeable from 'zignal-landscape/lib/themeable';
import Save1Icon from 'zignal-landscape/lib/Icon/Save1Icon';

const SidebarNumberedItem = ({
  styles,
  activeIndex = 0,
  index = 0,
  children,
  onClick = noop
}) => {
  const isComplete = index < activeIndex;
  const isActive = index === activeIndex;

  const itemClassNames = {
    [styles.SidebarNumberedItem]: true,
    [styles.complete]: isComplete,
    [styles.active]: isActive,
    [styles.incomplete]: !isComplete && !isActive,
  };

  return (
    <div className={classnames(itemClassNames)} onClick={isComplete ? onClick : noop}>
      <span className={styles.circle}>
        { isComplete ? <Save1Icon /> : <span>{index+1}</span> }
      </span>
      <span>{children}</span>
    </div>
  );
};

SidebarNumberedItem.propTypes = {
  styles: PropTypes.object.isRequired,
  activeIndex: PropTypes.number,
  index: PropTypes.number,
  children: PropTypes.node,
  onClick: PropTypes.func
};

export default themeable(SidebarNumberedItem);
